export const filterNotSubscriptionCharges = (charges) => {
  if (!charges) {
    return [];
  }

  return charges.filter((charge) => {
    // leave all pending
    if (charge.status === 'pending') {
      return true;
    }
    return charge.line_items.find(
      (item) => item.purchase_item_type === 'subscription',
    );
  });
};
